import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, createStaticVNode as i, openBlock as a } from "vue";
//#region ../src/illustrations/atomic-pathway.vue
var o = {
	name: "DtIllustrationAtomicPathway",
	props: { ariaLabel: {
		type: String,
		default: void 0
	} },
	emits: ["loaded"],
	computed: {
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-illustration";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], c = ["fill"], l = ["id"];
function u(e, t, o, u, d, f) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		focusable: "false",
		role: "img",
		"data-name": "Atomic Pathway",
		class: "d-illustration d-illustration--atomic-pathway",
		width: "200",
		height: "200",
		viewBox: "0 0 200 200",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		t[1] || (t[1] = r("circle", {
			cx: "74.9676",
			cy: "111.584",
			r: "57.5418",
			stroke: "var(--dt-color-surface-contrast)",
			"stroke-dasharray": "2 2"
		}, null, -1)),
		r("circle", {
			cx: "74.968",
			cy: "111.584",
			r: "35.4006",
			fill: `url(#${e.uniqueID}paint0_linear_1442_183)`
		}, null, 8, c),
		t[2] || (t[2] = i("<circle cx=\"5.82409\" cy=\"5.82409\" r=\"5.82409\" transform=\"matrix(-1 0 0 1 186.643 50.2524)\" fill=\"var(--dt-color-surface-contrast)\"></circle><circle cx=\"5.82409\" cy=\"5.82409\" r=\"5.82409\" transform=\"matrix(-1 0 0 1 44.8509 17.1189)\" fill=\"var(--dt-color-surface-contrast)\"></circle><circle cx=\"167.268\" cy=\"157.963\" r=\"6.17617\" fill=\"var(--dt-color-surface-contrast)\"></circle><circle cx=\"70.6146\" cy=\"186.352\" r=\"6.84948\" fill=\"var(--dt-color-surface-contrast)\"></circle><circle cx=\"100.088\" cy=\"100.088\" r=\"96.5883\" stroke=\"var(--dt-color-surface-contrast)\" stroke-dasharray=\"2 2\"></circle><path d=\"M127.841 92.7378V111.349\" stroke=\"var(--dt-color-surface-contrast)\" stroke-width=\"2.27211\" stroke-miterlimit=\"10\"></path><path d=\"M118.533 102.046H137.144\" stroke=\"var(--dt-color-surface-contrast)\" stroke-width=\"2.27211\" stroke-miterlimit=\"10\"></path><path d=\"M121.256 95.4614L134.421 108.626\" stroke=\"var(--dt-color-surface-contrast)\" stroke-width=\"2.27211\" stroke-miterlimit=\"10\"></path><path d=\"M121.256 108.626L134.421 95.4614\" stroke=\"var(--dt-color-surface-contrast)\" stroke-width=\"2.27211\" stroke-miterlimit=\"10\"></path>", 9)),
		r("defs", null, [r("linearGradient", {
			id: `${e.uniqueID}paint0_linear_1442_183`,
			x1: "121.996",
			y1: "160.057",
			x2: "83.1019",
			y2: "63.6407",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [
			r("stop", {
				offset: "0.297344",
				"stop-color": "#7C52FF"
			}, null, -1),
			r("stop", {
				offset: "0.762314",
				"stop-color": "#F9008E"
			}, null, -1),
			r("stop", {
				offset: "1",
				"stop-color": "#F6AB3C"
			}, null, -1)
		])], 8, l)])
	], 8, s);
}
var d = /* @__PURE__ */ t(o, [["render", u]]);
//#endregion
export { d as default };

//# sourceMappingURL=atomic-pathway.js.map